module.exports = __webpack_public_path__ + "static/media/b-logo-white-temp.e37c6ea9.svg";